import React, { useEffect, useRef, useState } from 'react'
import BaseButton from '@/components/common/BaseButton'
import KOMOKU_ICON_GRAY from '@public/assets/action/komoku-logo-gray.svg'
import KOMOKU_ICON_COLOR from '@public/assets/action/komoku-logo-color.svg'
import ACCEPT_ICON from '@public/assets/action/check-ocg.svg'
import type { NarrativeOcgValidationHint } from '../types'
import {
  getOcgFieldSuggestion,
  type OcgFieldName,
} from '../utils/fieldViolations'
import { getActionClassName } from '../utils/classNames'

export const NarrativeOcgFieldSuggestion = ({
  field,
  validationHint,
  currentValue,
  onAccept,
}: {
  field: OcgFieldName
  validationHint?: NarrativeOcgValidationHint
  currentValue?: string | number | null
  onAccept: (value: unknown) => void
}) => {
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)
  const violation = getOcgFieldSuggestion(validationHint, field)

  useEffect(() => {
    if (!open) return
    const close = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  if (!violation) return null

  return (
    <div className="narrative-ocg-field-suggestion" ref={rootRef}>
      <button
        aria-label="Show MIRA suggestion"
        className="narrative-ocg-field-suggestion__trigger"
        onClick={() => setOpen(value => !value)}
        type="button"
      >
        <img
          alt=""
          className="narrative-ocg-field-suggestion__icon narrative-ocg-field-suggestion__icon--default"
          src={KOMOKU_ICON_GRAY}
        />
        <img
          alt=""
          className="narrative-ocg-field-suggestion__icon narrative-ocg-field-suggestion__icon--hover"
          src={KOMOKU_ICON_COLOR}
        />
      </button>
      {open ? (
        <div className="narrative-ocg-field-suggestion__popover" role="dialog">
          <strong>MIRA Suggestion</strong>
          <div className="narrative-ocg-field-suggestion__values">
            <span>{currentValue ?? ''}</span>{' '}
            <b>{String(violation.suggestedValue)}</b>
          </div>
          <BaseButton
            className={`${getActionClassName('primary', false, true)} narrative-ocg-field-suggestion__accept`}
            onClick={() => {
              onAccept(violation.suggestedValue)
              setOpen(false)
            }}
            themeColor="dark"
            type="button"
          >
            <span className="inline-flex h-4 items-center justify-center gap-1.5 leading-4">
              <img
                alt=""
                className="narrative-ocg-field-suggestion__accept-icon"
                src={ACCEPT_ICON}
              />
              <span className="leading-4">Accept</span>
            </span>
          </BaseButton>
        </div>
      ) : null}
    </div>
  )
}
